var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg07Music(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5006 0.00119019C115.645 0.00119019 149 33.355 149 74.5006C149 115.645 115.645 148.999 74.5006 148.999C33.3573 148.999 0.00117493 115.645 0.00117493 74.5006C0.00117493 33.355 33.3573 0.00119019 74.5006 0.00119019Z",
    fill: "url(#paint0_linear_1_68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.841 87.6057C108.011 82.3007 110.114 75.5908 110.523 68.9517C110.781 64.6898 109.832 60.2157 107.775 56.0092C104.55 49.4007 99.0088 45.6892 93.6567 42.1027C89.6624 39.426 85.8872 36.8991 83.2188 33.289L82.7403 32.6454C81.1621 30.5263 79.3813 28.1243 79.0984 26.1076C78.8155 24.0674 76.9639 22.6154 74.939 22.7333C72.8823 22.8747 71.29 24.5778 71.29 26.6416V96.5691C68.0017 94.5749 63.9519 93.3515 59.5168 93.3515C48.7029 93.3515 39.8963 100.391 39.8963 109.047C39.8963 117.704 48.7029 124.744 59.5168 124.744C70.3318 124.744 79.1373 117.704 79.1373 109.047V63.3084C85.0316 65.5608 94.6774 71.2971 97.3293 84.6945C96.8354 85.4241 96.364 86.209 95.8148 86.8372C94.3792 88.4614 94.5359 90.9412 96.1683 92.3697C97.7854 93.8147 100.265 93.6414 101.701 92.0173C102.753 90.8245 103.687 89.4267 104.581 87.9675C104.676 87.8579 104.762 87.7401 104.841 87.6057Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_68",
    x1: 127.179,
    y1: 127.179,
    x2: 21.8221,
    y2: 21.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Music);
export default __webpack_public_path__ + "static/media/07_music.2bcd04ccc1a59f0d15a77cf0788026e5.svg";
export { ForwardRef as ReactComponent };